<template>
  <div class="whAll">
    
  </div>
</template>
<script>

export default {
  
  data() {
    return {
       
    }
  },
  mounted() {
   
  },
  methods: {
   
  }
};
</script>